import {asyncNames} from '../../lib/asyncUtil'
import {USERS, SIGN_OUT} from '../actionTypes'

const initialState = {loading: false, users: [], currentUser: {}, failed: false, error: null, usersMeta: {}}

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case asyncNames(USERS).loading:
      return {...state, loading: action.data}
    case asyncNames(USERS).success:
      let updated = {...state, loading: false, failed: false, error: null}

      if (Array.isArray(action.data))
        updated = {...updated, users: action.data, usersMeta: action.meta}
      else
        updated = {...updated, currentUser: action.data, users: [action.data]}

      return updated
    case asyncNames(USERS).failure:
      return {...state, loading: false, error: action.data.error, failed: action.data.status}
    case asyncNames(SIGN_OUT).success:
      return {...state, users: [], currentUser: {}}
    default:
      return state
  }
}

export default usersReducer
